import api from "@/lib/api";
import { toast } from "sonner";

export async function downloadRcaPdf(rca) {
  try {
    const res = await api.get(`/rcas/${rca.id}/pdf`, { responseType: "blob" });
    const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || `${rca.key}.pdf`;
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch { toast.error("Could not generate PDF"); }
}
